import { gql } from "@apollo/client";

export const CREATE_CUSTOM_SERVICE_TASK = gql`
  mutation createCustomVehicleServiceTask(
    $serviceTaskId: String!
    $vehicleServiceTask: VehicleServiceTaskInput!
  ) {
    createCustomVehicleServiceTask (serviceTaskId:$serviceTaskId,vehicleServiceTask: $vehicleServiceTask) {
      id
      name
      cost
      itemType
      taskType
      description
  }
}
`;

export const UPDATE_VEHICLE_SERVICE_TASK = gql`
  mutation updateVehicleServiceTask(
    $serviceTaskId: String!
    $serviceTaskItemId: String!
    $vehicleServiceTask: VehicleServiceTaskInput!
  ) {
    updateVehicleServiceTask (
      serviceTaskId:$serviceTaskId,
      serviceTaskItemId:$serviceTaskItemId,
      vehicleServiceTask: $vehicleServiceTask
  ) {
      id
      name
      cost
      itemType
      taskType
      description
  }
}
`;

export const DELETE_VEHICLE_SERVICE_TASK = gql`
  mutation deleteVehicleServiceTask(
    $serviceTaskId: String!
  ) {
    deleteVehicleServiceTask (serviceTaskId:$serviceTaskId) {
      success
      message
  }
}
`;